package top.wcpe.allincore.ui.runtime.ir.api

import top.wcpe.allincore.ui.runtime.reactive.Reactive
import top.wcpe.allincore.ui.runtime.reactive.Signal
import kotlin.jvm.JvmField
import kotlin.jvm.JvmStatic

/** 单个 placeholder 的响应式运行时视图。 */
class PlaceholderEntry(val value: Signal<Any?>, val available: Signal<Boolean>) {
    companion object {
        @JvmField val UNAVAILABLE: PlaceholderEntry = PlaceholderEntry(
            Reactive.signal(null),
            Reactive.signal(false),
        )

        @JvmStatic fun unavailable(): PlaceholderEntry = UNAVAILABLE
    }
    fun currentValue(): Any? = value.get()
    fun currentAvailable(): Boolean = available.get() == true
}
